const passWordInputToggles = document.querySelectorAll('.toggle-password-visibility');

if (passWordInputToggles.length) {
    [].forEach.call(passWordInputToggles, toggleButton => {
        let input = toggleButton.parentElement.querySelector('input');

        toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (input.type === "password") {
                input.type = "text";
            } else {
                input.type = "password";
            }
        })
    })
}